module.exports = __webpack_public_path__ + "static/media/select.72eb4fea.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/LandingPage/images/select.PNG
// module id = 1458
// module chunks = 0